import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { ensureCurrentVersion } from './services/versionGate'

// Fire-and-forget version check on app boot. If the running bundle is older
// than what's deployed, the gate hard-reloads. We don't await — the React
// tree mounts immediately so users on the latest version see no delay; the
// rare reload case (stale tab + extension/SW interference) just replaces
// the page mid-mount.
void ensureCurrentVersion()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
